import Rete from 'rete'

import CONST_SOCKET from '../../const/socket'
import ButtonTemplate from './ButtonTemplate'
import lingualName from '../../const/lingualName'
import CONST_COMPONENT from '../../const/component'
import { lang } from '../../assets/lang'

const instagram_addon = window.xitFlowBuilderData.instagram_addon
var recurring_notification_addon = window.xitFlowBuilderData.recurring_notification_addon
var instagram_recurring_notification_addon = window.xitFlowBuilderData.instagram_recurring_notification_addon

var recurring_notification_display = 0;
if(!instagram_addon && recurring_notification_addon)
  recurring_notification_display = 1;
if(instagram_addon && instagram_recurring_notification_addon)
  recurring_notification_display = 1;

export default class ButtonComponent extends Rete.Component {
  constructor(config) {
    super(CONST_COMPONENT.BUTTON)

    this.data.component = ButtonTemplate
    this.socket = config ? config.sockets : null
    this.isSequenceAddonAvailable = !! window.xitFlowBuilderData.sequence_addon
    this.isConditionAddonAvailable = !! window.xitFlowBuilderData.messenger_bot_condition
    this.isUserInputFlowAddonAvailable = !! window.xitFlowBuilderData.user_input_flow_addon
    this.isInstagramAddonAvailable = !! window.xitFlowBuilderData.instagram_addon
    this.isRcnAddonAvailable = !! window.xitFlowBuilderData.recurring_notification_addon
    this.is_openai_addon_access = !!window.xitFlowBuilderData.is_openai_addon_access
    this.http_api_module = !! window.xitFlowBuilderData.http_api_module
  }

  builder(node) {
    node.lingualName = lingualName.BUTTON
    this.setConnection()

    const buttonInput = new Rete.Input(CONST_SOCKET.BUTTON_INPUT, lang.button_socket_input_reply, this.socket.buttonInput, true)
    const buttonOutput = new Rete.Output(CONST_SOCKET.BUTTON_OUTPUT, lang.button_socket_output_next, this.socket.buttonOutput, false)
    const buttonOutputSequence = new Rete.Output(CONST_SOCKET.BUTTON_OUTPUT_SEQUENCE, lang.button_socket_output_sequence, this.socket.buttonOutputSequence, false)

    return node
      .addInput(buttonInput)
      .addOutput(buttonOutput)
      .addOutput(buttonOutputSequence)
  }

  // eslint-disable-next-line
  worker(node, inputs, outputs) {
    outputs[CONST_SOCKET.BUTTON_OUTPUT] = node.data
  }
  
  setConnection() {
    // Button may be connected to:
    this.socket.buttonOutput.combineWith(this.socket.textInput)
    if(this.is_openai_addon_access)
      this.socket.buttonOutput.combineWith(this.socket.openaiInput)
    this.socket.buttonOutput.combineWith(this.socket.carouselInput)
    this.socket.buttonOutput.combineWith(this.socket.imageInput)
    
    if (!this.isInstagramAddonAvailable) {
      this.socket.buttonOutput.combineWith(this.socket.facebookMediaInput)
      this.socket.buttonOutput.combineWith(this.socket.videoInput)
      this.socket.buttonOutput.combineWith(this.socket.audioInput)
      this.socket.buttonOutput.combineWith(this.socket.fileInput)
      // this.socket.buttonOutput.combineWith(this.socket.otnInput)
    }
    
    if(recurring_notification_display)
      this.socket.buttonOutput.combineWith(this.socket.rcnInput)

    this.socket.buttonOutput.combineWith(this.socket.ecommerceInput)
    this.socket.buttonOutput.combineWith(this.socket.genericTemplateInput)
    this.socket.buttonOutput.combineWith(this.socket.componentListInput)

    if (this.isUserInputFlowAddonAvailable) {
      this.socket.buttonOutput.combineWith(this.socket.userInputFlowInput)
    }

    if(this.http_api_module)
    {
      this.socket.buttonOutput.combineWith(this.socket.httpApiInput)
    }

    // Output: Sequence
    if (this.isSequenceAddonAvailable) {
      this.socket.buttonOutputSequence.combineWith(this.socket.sequenceInput)    
    }
    // Output: Condition
    if (this.isConditionAddonAvailable) {  
      this.socket.buttonOutput.combineWith(this.socket.conditionInput)
    }
  }
}